import React, { Suspense, useEffect } from "react";
import "./App.css";
import MyRoutes from "./MyRoutes";
import ScrollToTop from "./ScrollToTop";

const App = () => {
    // DEBUG: Log App Mount
    useEffect(() => {
        console.log("📱 [App] Component Mounted (This should only happen ONCE per page load)");
    }, []);

    // Init Theme
    useEffect(() => {
        try {
            const saved = localStorage.getItem("theme");
            console.log("🎨 [App] Initializing Theme:", saved || "light");
            document.documentElement.setAttribute("data-theme", saved || "light");
        } catch (e) {
            console.error("❌ [App] Theme Error:", e);
        }
    }, []);

    return (
        <div className="app-container">
            <ScrollToTop />
            <Suspense fallback={<div className="spinner"></div>}>
                {/* If logs show [App] mounting multiple times, 
                    something above this (in index.js) is forcing re-renders.
                */}
                <MyRoutes />
            </Suspense>
        </div>
    );
};

export default App;